import { useQuery } from '@tanstack/react-query';
import axios from '../common/api/request';
import { DesignatedOperatorRelationsResponse } from '../types/designatedOperatorRelations';

// ── Query keys ───────────────────────────────────────────────────────────────

export const settingsYearsKeys = {
  all: ['settings-years'] as const,
};

// ── Hook ─────────────────────────────────────────────────────────────────────

/**
 * Fetch the full list of accounting years from the Settings superset
 * (NOT preference-filtered).
 *
 * Endpoint: `GET /designated-operator-relations`
 *
 * Years are extracted from the `byYear` keys and returned in descending order.
 */
export function useSettingsYears() {
  const { data, isLoading, error, refetch } = useQuery<string[]>({
    queryKey: settingsYearsKeys.all,
    queryFn: async () => {
      const resp = await axios.get<DesignatedOperatorRelationsResponse>(
        '/designated-operator-relations',
      );
      const yearKeys = Object.keys(resp.data.byYear ?? {});
      return yearKeys.sort((a, b) => Number(b) - Number(a));
    },
  });

  return {
    years: data ?? [],
    isLoading,
    error,
    refetch,
  };
}

